export function normalizeWarehouseIds(ids) {
  if (!Array.isArray(ids)) return [];
  return [...new Set(ids.map((id) => Number(id)).filter((id) => Number.isFinite(id) && id > 0))];
}

export function isReceptionConsumeAutomationActive({
  receptionConsumeButtonEnabled,
  receptionConsumeWarehouseIds,
  warehouseId,
}) {
  if (!receptionConsumeButtonEnabled) return false;
  const normalizedWarehouseId = Number(warehouseId);
  if (!Number.isFinite(normalizedWarehouseId) || normalizedWarehouseId <= 0) return false;
  const warehouseIds = normalizeWarehouseIds(receptionConsumeWarehouseIds);
  return warehouseIds.includes(normalizedWarehouseId);
}
